import script from "./YomokkaNavi.vue?vue&type=script&lang=ts&setup=true"
export * from "./YomokkaNavi.vue?vue&type=script&lang=ts&setup=true"

import "./YomokkaNavi.vue?vue&type=style&index=0&id=2c579812&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2c579812"]])

export default __exports__